<template>
    <v-container class="hn-progress">
        <v-row class="v-patient-overview-hn-progress">
            <v-col cols="12" class="row border mb-2 ml-1" v-if="HNAnswerDate != null">
                <v-col cols="1" align="center" style="display: flex; align-items: flex-start; justify-content: center;">
                    <smart-icon :icon="HNAnswerIcon" class="mr-3" />
                </v-col>
                <v-col cols="8">
                    <p>{{ $t('nutritionDiet.overallDiet', {
                        params: {
                            answer: HNAnswer.toLowerCase()
                        }
                    }) }}</p>
                </v-col>
                <v-col cols="3">
                    <p class="hn-progress__reported-on">{{ $ucfirst($t("pa.reportedOn")) }} {{ HNAnswerDate }}</p>
                </v-col>
            </v-col>
            <v-col cols="12" class="row border mb-2 ml-1" v-if="nutritionScorePercent != null">
                <v-col cols="9">
                    <p>{{ $t('nutritionScore.nutritionScore', { params: { value: Math.round(parseFloat(nutritionScorePercent)) } }) }}</p>
                </v-col>
                <v-col cols="3">
                    <p class="hn-progress__reported-on">{{ $ucfirst($t("pa.reportedOn")) }} {{ scoreDate }}</p>
                </v-col>
            </v-col>
            <v-col cols="12" class="row border mb-2 ml-1" v-if="challengesHNAnswers.length">
                <v-col cols="9">
                    <p><b>{{ $t('healthyNutritionChallenges.healthyNutritionChallenges') }}</b></p>
                    <ul v-for="answer in challengesHNAnswers" :key="answer">
                        <li>{{ answer }}</li>
                    </ul>
                </v-col>
                <v-col cols="3">
                    <p class="hn-progress__reported-on">{{ $ucfirst($t("pa.reportedOn")) }} {{ challengesHNAnswersDate }}
                    </p>
                </v-col>
            </v-col>
            <!-- No data message -->
            <v-col v-if="HNAnswerDate == null && nutritionScorePercent == null && challengesHNAnswers.length <= 0">
                <p>{{ $ucfirst($t('noData')) }}</p>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import SmartIcon from '../../../components/Parts/SmartIcon';
import gql from "graphql-tag";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "PatientOverviewHNProgressGeneral",
    components: {
        SmartIcon
    },
    computed: {
        ...mapGetters({
            patientId: "patientSummary/id",
        }),
    },
    mounted: function () {
        this.loadData();
    },
    watch: {
        patientId: function () {
            this.loadData();
        },
    },
    data: function () {
        return {
            nutritionScorePercent: null,
            HNAnswer: null,
            HNAnswerKey: null,
            HNAnswerDate: null,
            HNAnswerIcon: null,
            scoreDate: null,
          challengesHNAnswers: [],
            challengesHNAnswersDate: null,
        }
    },
    methods: {
        loadData: function () {
            this.loadNutritionScore();
            this.loadHNA();
            this.loadHNChallenges();
        },

        loadNutritionScore: function () {
            this.$app.apolloMobileClient
                .query({
                    query: gql`
                        query myScoreForThisWeek(
                            $patientId: Int,
                        ){
                    myHealthyNutritionWeek(patientId: $patientId) {
                        id
                        startDate
                        entryDate
                      isCompleted
                      score
                      scoreAsPercent
                      
                      achievedGoals {
                        key
                        foodGroupKey
                        answer
                        answerLabel
                        goal {
                          id
                          frequencyLabel
                          typeLabel
                          unitLabel
                          foodGroup {
                            key
                            label
                            unitLabel
                          }
                        }
                      }
                    }
                  }
                    `,
                    variables: {
                        patientId: parseInt(this.patientId),
                    },
                })
                .then((result) => {
                    // console.log(result.data.myHealthyNutritionWeek);
                    // Set score in variable.
                    this.nutritionScorePercent = result.data.myHealthyNutritionWeek.scoreAsPercent;
                    this.scoreDate = result.data.myHealthyNutritionWeek.entryDate ?
                      moment(result.data.myHealthyNutritionWeek.entryDate).format('DD/MM/YYYY') : null;
                });
        },

        loadHNA() {
            this.$app.apolloMobileClient
                .query({
                    query: gql`
                        query myQuestionnaireForms(
                            $patientId: String!
                        ){
                            myQuestionnaireForms(
                                conditions : {gate : and, inputs : [
                                    {field : completed, value : "1"},
                                    {field : key, value : "HNA"}
                                ]},
                                orders : {field : updatedAt, direction : desc}
                                limit : 1
                                functions: {
                                    function: patientId,
                                    parameters: [$patientId]
                                }
                            ){
                                questionnaire{
                                    key
                                }
                                id
                                completed
                                entryDate
                                entries{
                                    givenAnswers{
                                        key
                                        text
                                    }
                                }
                            }
                        }
                    `,
                    variables: {
                        patientId: this.patientId
                    }
                })
                .then((result) => {
                    if (result.data.myQuestionnaireForms.length) {
                        if (result.data.myQuestionnaireForms[0].entries.length) {

                            let answers = {
                                EXCELLENT: {
                                    icon: 'icon-smiley5',
                                },
                                VERY_GOOD: {
                                    icon: 'icon-smiley4',
                                },
                                GOOD: {
                                    icon: 'icon-smiley3',
                                },
                                FAIR: {
                                    icon: 'icon-smiley2',
                                },
                                POOR: {
                                    icon: 'icon-smiley1',
                                },
                            }

                            this.HNAnswer = result.data.myQuestionnaireForms[0].entries[0].givenAnswers[0].text;
                            this.HNAnswerIcon = answers[result.data.myQuestionnaireForms[0].entries[0].givenAnswers[0].key].icon;
                            this.HNAnswerKey = result.data.myQuestionnaireForms[0].entries[0].givenAnswers[0].key;
                            this.HNAnswerDate = moment(result.data.myQuestionnaireForms[0].entryDate).format('DD/MM/YYYY');
                        }
                    }

                });
        },

        answerToBarrierLabel(answer, entryOther) {
          switch (answer.key){
            case 'TIME_CONSTRAINT':
              return this.$t('nutritionBarriers.shoppingAnswer', { catalog: "questionnaires" })
            case 'LIMITED_OPTIONS_AT_STORE':
              return this.$t('nutritionBarriers.storeAnswer', { catalog: "questionnaires" })
            case 'LIMITED_OPTIONS_AT_RESTAURANT':
              return this.$t('nutritionBarriers.restaurantAnswer', { catalog: "questionnaires" })
            case 'PRICE':
              return this.$t('nutritionBarriers.expensiveAnswer', { catalog: "questionnaires" })
            case 'LACK_OF_SOCIAL_SUPPORT':
              return this.$t('nutritionBarriers.lackSupportAnswer', { catalog: "questionnaires" })
            case 'SOCIAL_GROUP_OPPOSITION':
              return this.$t('nutritionBarriers.oppositionAnswer', { catalog: "questionnaires" })
            case 'TASTE':
              return this.$t('nutritionBarriers.tasteAnswer', { catalog: "questionnaires" })
            case 'LACK_OF_SELF_RESTRAINT':
              return this.$t('nutritionBarriers.eatLotAnswer', { catalog: "questionnaires" })
            case 'DAILY_HABITS':
              return this.$t('nutritionBarriers.habitsAnswer', { catalog: "questionnaires" })
            case 'LACK_OF_WILLPOWER':
              return this.$t('nutritionBarriers.willpowerAnswer', { catalog: "questionnaires" })
            case 'COOKING_SKILLS':
              return this.$t('nutritionBarriers.cookingSkillAnswer', { catalog: "questionnaires" })
            case 'KNOWLEDGE':
              return this.$t('nutritionBarriers.knowledgeAnswer', { catalog: "questionnaires" })
            case 'OTHER':
              return this.$t('medicationRejectionOfGuideline.other', { catalog: "app_dashboard" }) +
                  ' ' + entryOther?.givenAnswers[0]?.openAnswer
            case 'NO_IDENTIFIED_BARRIERS':
              return this.$t('nutritionBarriers.noBarriersAnswer', { catalog: "questionnaires" })
          }
           return answer.text;
        },

        loadHNChallenges: function () {
            this.$app.apolloMobileClient
                .query({
                    query: gql`
                        query myQuestionnaireForms(
                            $patientId: String!
                        ){
                            myQuestionnaireForms(
                                conditions : {gate : and, inputs : [
                                    {field : key, value : "HEALTHYNUTRITIONCHALLENGES"}
                                ]},
                                orders : {field : updatedAt, direction : desc}
                                limit : 1
                                functions: {
                                    function: patientId,
                                    parameters: [$patientId]
                                }
                            ){
                                questionnaire{
                                    key
                                }
                                id
                                completed
                                entryDate
                                entries{
                                    question {
                                        key
                                        text
                                        sequence
                                    }
                                    givenAnswers{
                                        id
                                        key
                                        text
                                        openAnswer
                                    }
                                }
                            }
                        }
                    `,
                    variables: {
                        patientId: this.patientId
                    }
                })
                .then((result) => {
                    if (result.data.myQuestionnaireForms.length) {
                        const entries = result.data.myQuestionnaireForms[0].entries;
                        const entryBarriers = entries.find(entry => entry.question.key === 'BARRIERS');
                        const entryOther = entries.find(entry => entry.question.key === 'OTHER')

                        if (entryBarriers.givenAnswers.length) {
                            entryBarriers.givenAnswers.forEach(answer => {
                                if (answer.text != null) {
                                    this.challengesHNAnswers.push(this.answerToBarrierLabel(answer, entryOther));
                                }
                            })
                        }

                        this.challengesHNAnswersDate = moment(result.data.myQuestionnaireForms[0].entryDate).format('DD/MM/YYYY');
                    }
                })
        }
    }
}

</script>